import { render, staticRenderFns } from "./Vtechnology.vue?vue&type=template&id=5683648b"
import script from "./Vtechnology.vue?vue&type=script&lang=js"
export * from "./Vtechnology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports